(function () {
  'use strict';

  var SELECTOR = [
    'details.facets__disclosure-vertical',
    'details.almam-stores__city',
    'details.almam-cart-note',
    '.accordion > details'
  ].join(',');

  var DURATION = 320;
  var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var running = new WeakMap();

  function closedHeight(details, summary) {
    var styles = getComputedStyle(details);
    return summary.offsetHeight +
      parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom) +
      parseFloat(styles.borderTopWidth) + parseFloat(styles.borderBottomWidth);
  }

  function animate(details, summary, opening) {
    var previous = running.get(details);
    var startHeight = details.getBoundingClientRect().height;
    if (previous) previous.cancel();

    details.dataset.motion = opening ? 'opening' : 'closing';
    details.style.overflow = 'hidden';
    details.open = true;

    var endHeight = opening ? details.getBoundingClientRect().height : closedHeight(details, summary);

    var animation = details.animate(
      { height: [startHeight + 'px', endHeight + 'px'] },
      { duration: DURATION, easing: EASING }
    );
    running.set(details, animation);

    animation.onfinish = function () {
      running.delete(details);
      details.open = opening;
      details.style.removeProperty('overflow');
      delete details.dataset.motion;
    };
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest ? event.target.closest('summary') : null;
    if (!summary) return;

    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS' || !details.matches(SELECTOR)) return;
    if (reducedMotion.matches || typeof details.animate !== 'function') return;

    event.preventDefault();
    var opening = details.dataset.motion ? details.dataset.motion === 'closing' : !details.open;
    animate(details, summary, opening);
  });
})();
